import api from './api';
import type { ContractDocument } from '@/types';

/**
 * Upload one or more documents to a contract
 * POST /api/clc/contracts/{contractId}/documents
 */
export const uploadDocuments = async (
    contractId: number,
    files: File[],
    documentType?: string,
    onUploadProgress?: (progressEvent: any) => void
) => {
    try {
        const formData = new FormData();
        
        files.forEach(file => {
            formData.append('documents[]', file);
        });

        if (documentType) {
            formData.append('document_type', documentType);
        }

        const response = await api.post(
            `/api/clc/contracts/${contractId}/documents`,
            formData,
            {
                onUploadProgress,
            }
        );

        return response.data;
    } catch (error: any) {
        console.error('Error uploading documents:', {
            status: error.response?.status,
            data: error.response?.data,
            message: error.message,
        });
        if (error.response) {
            return error.response.data;
        }
        throw error;
    }
};

/**
 * Get all documents for a contract
 * GET /api/clc/contracts/{contractId}/documents
 */
export const getContractDocuments = async (contractId: number) => {
    try {
        const response = await api.get(`/api/clc/contracts/${contractId}/documents`);
        return response.data;
    } catch (error: any) {
        console.error('Error fetching contract documents:', error);
        if (error.response) {
            return error.response.data;
        }
        throw error;
    }
};

/**
 * Download a document
 * GET /api/clc/contracts/{contractId}/documents/{documentId}
 */
export const downloadDocument = async (contractId: number, documentId: number) => {
    try {
        const response = await api.get(
            `/api/clc/contracts/${contractId}/documents/${documentId}`,
            {
                responseType: 'blob',
            }
        );
        return response;
    } catch (error: any) {
        console.error('Error downloading document:', error);
        if (error.response) {
            return error.response.data;
        }
        throw error;
    }
};

/**
 * Delete a document
 * DELETE /api/clc/contracts/{contractId}/documents/{documentId}
 */
export const deleteDocument = async (contractId: number, documentId: number) => {
    try {
        const response = await api.delete(
            `/api/clc/contracts/${contractId}/documents/${documentId}`
        );
        return response.data;
    } catch (error: any) {
        console.error('Error deleting document:', error);
        if (error.response) {
            return error.response.data;
        }
        throw error;
    }
};
